import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { site } from "@/config/site";

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="container-x grid gap-10 py-12 md:py-16 lg:grid-cols-4">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-fire-fill text-xl" />
            </span>
            <span className="font-heading text-lg font-black text-foreground-950">
              {site.name}
            </span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
            {site.description}
          </p>
        </div>

        <div>
          <h3 className="font-heading text-sm font-bold text-foreground-950">剧情分类</h3>
          <ul className="mt-4 flex flex-wrap gap-x-5 gap-y-2">
            {categories.map((c) => (
              <li key={c.slug}>
                <Link
                  to={`/category/${c.slug}`}
                  className="text-sm text-foreground-600 transition-colors hover:text-primary-700"
                >
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-heading text-sm font-bold text-foreground-950">快速导航</h3>
          <ul className="mt-4 space-y-2">
            <li>
              <Link to="/" className="text-sm text-foreground-600 hover:text-primary-700">
                首页
              </Link>
            </li>
            <li>
              <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-700">
                关于我们
              </Link>
            </li>
            <li>
              <Link to="/faq" className="text-sm text-foreground-600 hover:text-primary-700">
                常见问题
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-200 bg-background-200/40">
        <div className="container-x flex flex-col items-center justify-between gap-3 py-5 text-xs text-foreground-500 sm:flex-row">
          <p>© {new Date().getFullYear()} {site.name} · 仅供同人作品交流整理，非官方站点</p>
          <p>联系方式：{site.email}</p>
        </div>
      </div>
    </footer>
  );
}